module.exports = __webpack_public_path__ + "static/media/CPService.070eec8e.png";